import './ui/config/sentry'
import 'moment/dist/locale/pt-br'

import { ChakraProvider } from '@chakra-ui/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import moment from 'moment'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'
moment.locale('pt-br')

import './shared/i18n'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import 'primereact/resources/primereact.min.css'
import 'react-day-picker/dist/style.css'
import './ui/styles/main.css'

import App from './App'
import { queryClient } from './ui/config/queryClient'
import customTheme from './ui/theme/customTheme'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <QueryClientProvider client={queryClient}>
    <ChakraProvider theme={customTheme}>
      <RecoilRoot>
        <ReactQueryDevtools />
        <App />
      </RecoilRoot>
    </ChakraProvider>
  </QueryClientProvider>
)
